


import { useState } from "react";
import { NavLink } from "react-router";
import logo from '../../assets/logo-resize.png';
import { routes } from "../../routes";

export const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);



    return (
        <nav className="fixed top-0 left-0 w-full bg-gradient-to-r from-green-200 to-green-600 shadow-md z-50">
            <div className="w-full px-4 sm:px-6 lg:px-8 p-4">
                <div className="flex justify-between h-16">
                    <div className="flex items-center">
                        <a href="/" className="text-xl font-bold text-white">
                            <img src={logo} alt="logo" />
                        </a>
                    </div>

                    <div className="hidden md:flex space-x-6 items-center">
                        {routes.map((i, index) => (
                            <NavLink
                                key={index}
                                to={i.path}
                                className={({ isActive }) =>
                                    `text-white hover:text-gray-200 transition-colors duration-200 ${isActive ? 'underline' : ''
                                    }`
                                }
                            >
                                {i.title}
                            </NavLink>
                        ))}
                    </div>

                    <div className="flex items-center md:hidden">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="text-white focus:outline-none"
                            title="menu"
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                {isOpen ? (
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                ) : (
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M4 6h16M4 12h16M4 18h16"
                                    />
                                )}
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu - Now using the same routes as desktop */}
            {isOpen && (
                <div className="md:hidden bg-green-600 bg-opacity-90 px-4 pb-4 shadow-md">
                    {routes.map((i, index) => (
                        <NavLink
                            key={index}
                            to={i.path}
                            onClick={() => setIsOpen(false)}
                            className={({ isActive }) =>
                                `block py-2 text-white hover:text-gray-200 ${isActive ? 'underline font-medium' : ''}`
                            }
                        >
                            {i.title}
                        </NavLink>
                    ))}
                </div>
            )}
        </nav>
    );
}